import { render } from "./SimpleCheckbox.vue?vue&type=template&id=186ef7aa&scoped=true&ts=true"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=ts"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=ts"

import "./SimpleCheckbox.vue?vue&type=style&index=0&id=186ef7aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186ef7aa"]])

export default __exports__